import IconMoreAction from '@/components/assets/icon_more_action.svg'
import IconReport from '@/components/assets/icon_report.svg'
import PopoverMenu from '@/components/PopoverMenu'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import ViverseButton from '@/components/ViverseButton'
import { useAuthContext } from '@/context/AuthContext'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useConfigsContext } from '@/context/ConfigsContext'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

const WorldMoreActionButton = ({ handleReport }: { handleReport: () => void }) => {
  const t = useTranslations()
  const [open, setOpen] = useState(false)
  const { store } = useConfigsContext()
  const { isSignedIn } = useAuthContext()
  const {
    isOwner,
    roomData: { id: roomId },
  } = useCheckEnterRoomContext()
  const htcAuthKey = store?.credentials?.htcToken
  const canReport = isSignedIn && !isOwner && !!htcAuthKey && !!roomId

  const menuItems = [
    {
      key: 'report',
      visible: canReport,
      icon: <IconReport className="size-4" />,
      label: t('world-more-action.report'),
      onClick: () => {
        handleReport()
        setOpen(false)
      },
    },
  ].filter((item) => item.visible)

  if (menuItems.length === 0) return null

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <ViverseButton className="flex min-w-fit gap-2 p-2" variant="filter">
          <IconMoreAction
            className={cn(
              'size-[18px]',
              'fill-vive-primary-20 hover:fill-vive-white active:fill-vive-brand-50 size-[18px]',
              open && 'fill-vive-brand-50 hover:fill-vive-brand-50',
            )}
          />
        </ViverseButton>
      </PopoverTrigger>
      <PopoverContent side="bottom" align="end" className="mt-2 border-none bg-transparent p-0">
        <PopoverMenu className="bg-vive-primary-70 rounded-[3px] p-2">
          <PopoverMenu.Group>
            {menuItems.map((item) => (
              <PopoverMenu.Item key={item.key} className="rounded-none" onClick={item.onClick}>
                {item.icon}
                <div className="body-1 text-vive-primary-20">{item.label}</div>
              </PopoverMenu.Item>
            ))}
          </PopoverMenu.Group>
        </PopoverMenu>
      </PopoverContent>
    </Popover>
  )
}

export default WorldMoreActionButton
